import React, { useState } from 'react';
import {
  Box, TextField, Button, InputAdornment, IconButton, Alert
} from '@mui/material';
import { MdOutlineVisibility, MdOutlineVisibilityOff } from 'react-icons/md';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import BASE_API_URL from '../apis/index';
import styled from 'styled-components';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const navigate = useNavigate();

  const [form, setForm] = useState({
    password: '',
    confirmPassword: '',
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!token) {
      return setMessage({ type: 'error', text: 'Invalid or expired link' });
    }

    if (form.password !== form.confirmPassword) {
      return setMessage({ type: 'error', text: 'Passwords do not match' });
    }

    try {
      const res = await axios.post(`${BASE_API_URL}/api/auth/reset-password`, {
        token,
        newPassword: form.password,
      });
      setMessage({ type: 'success', text: res.data.message });
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setMessage({ type: 'error', text: err.response?.data?.error || 'Something went wrong' });
    }
  };

  return (
    <Wrapper className='d-flex align-items-center'>
      <Box maxWidth={400} mx="auto" mt={8} p={3} border="1px solid #ccc" borderRadius={2}>
        <h4 className='text-center fw-normal'> Reset Password</h4>

        {message.text && (
          <Alert severity={message.type} sx={{ mb: 2 }}>
            {message.text}
          </Alert>
        )}

        <TextField
          className='w-100'
          type={showPassword ? 'text' : 'password'}
          label="New Password"
          name="password"
          value={form.password}
          onChange={handleChange}
          margin="normal"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(prev => !prev)}>
                  {showPassword ? <MdOutlineVisibilityOff /> : <MdOutlineVisibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <TextField
          className='w-100'
          type={showConfirm ? 'text' : 'password'}
          label="Confirm Password"
          name="confirmPassword"
          value={form.confirmPassword}
          onChange={handleChange}
          margin="normal"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowConfirm(prev => !prev)}>
                  {showConfirm ? <MdOutlineVisibilityOff /> : <MdOutlineVisibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <Button
          className='w-100'
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          sx={{ mt: 2 }}
        >
          Reset Password
        </Button>
      </Box>
    </Wrapper>
  );
};

export default ResetPassword;

const Wrapper = styled.div`
min-height: 85vh;
`